module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.9045d0a7.png";